// http.js
const getSocket = () => {
    let url;
    // console.log("enviroment: ", process.env.NODE_ENV );
    switch (process.env.NODE_ENV) {
        case 'production':
            // url = 'http://127.0.0.1:8080';
            // url = 'http://192.168.12.110:8080';
            url = 'https://www.burchell.verinomics.com';
            // url = 'http://50.230.108.188:8080';
            break;
        default:
            // url = 'http://192.168.12.234:8080';
            url = 'http://127.0.0.1:8080';
    }
    return url;
}

export default getSocket;